/**
 * ContractorCompanyAccessViewElement — blok „Dostęp firm" kontrahenta jako
 * przenośny klocek kreatora layoutu (konfigurowalne zakładki, Kontrahenci).
 *
 * Mirror `ContractorContactsViewElement`. Element „widokowy": na realnej stronie
 * dispatchowany przez `contractorContextRenderers['contractor_company_access_view']`
 * (→ `ContractorAccessTab`); w builderze stub z rejestru.
 * `allowedModules: ['contractors']` — widoczny w palecie tylko dla Kontrahentów.
 */

import { KeyRound } from 'lucide-react';

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';
import i18n from '@/i18n';

export const ContractorCompanyAccessViewElement: LayoutElementDefinition = {
  type: 'contractor_company_access_view',
  category: 'tresc',
  isContainer: false,
  label: 'Dostęp firm',
  icon: 'key',
  allowedModules: ['contractors'],
  defaultSettings: () => ({}),
  render: ({ element }) => (
    <div
      className="rounded-lg border border-dashed border-border-secondary bg-bg-secondary p-4 text-center"
      data-testid={`contractor-company-access-view-element-${element.id}`}
      data-element-type="contractor_company_access_view"
    >
      <KeyRound className="mx-auto h-5 w-5 text-text-muted" aria-hidden="true" />
      <p className="mt-1 text-xs font-medium text-text-secondary">
        {i18n.t('tenant.contractors.companyAccessBlock.paletteLabel', {
          defaultValue: 'Dostęp firm',
        })}
      </p>
    </div>
  ),
};
